import queryString from "query-string";

import DefaultApiService from "./default";

const BASE = "SLN/Management/ManagementDashboard";
const ACTION_BASE = "SLN/Management/ManagementDashboardAction";
const ALL_REQUEST_BASE = "SLN/Management/AllRequest";

// Do not pass cancel=true — all getApi calls share one AbortController and
// parallel dashboard loads would cancel each other.

export const getManagementDashboardFilterOptions = (provinceId) =>
  DefaultApiService.getApi(
    `${BASE}/GetFilterOptions`,
    provinceId ? { provinceId } : {}
  );

export const getManagementDashboardExecutiveKpis = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetExecutiveKpis`, filter);

export const getManagementDashboardAnalytics = (periodDays = 30) =>
  DefaultApiService.getApi(`${BASE}/GetAnalytics`, {
    periodDays,
    aggregation: 1,
  });

export const getManagementDashboardFunnel = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetFunnel`, {
    ...filter,
    funnelMode: 1,
  });

export const getManagementDashboardTrends = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetTrends`, filter);

export const getManagementDashboardLendingOverview = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetLendingOverview`, filter);

export const getManagementDashboardMehrsanOverview = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetMehrsanOverview`, filter);

export const getManagementDashboardOperationalReadiness = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetOperationalReadiness`, filter);

export const getManagementDashboardAlerts = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetAlerts`, filter);

export const getManagementDashboardAcquisitionBreakdown = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetAcquisitionBreakdown`, filter);

export const getManagementDashboardStageAging = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetStageAging`, filter);

export const getManagementDashboardCriticalCases = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetCriticalCases`, filter);

export const getManagementDashboardContractorPerformance = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetContractorPerformance`, filter);

export const getManagementDashboardLoanPartnerPerformance = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetLoanPartnerPerformance`, filter);

export const getManagementDashboardOperationalBottlenecks = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetOperationalBottlenecks`, filter);

export const getManagementDashboardSlaPerformance = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetSlaPerformance`, filter);

export const getManagementDashboardHealthScore = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetManagementHealthScore`, filter);

export const getManagementDashboardActionCenter = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetActionCenter`, filter);

export const getManagementDashboardRequestRiskPredictions = (filter = {}, maxItems = 50) =>
  DefaultApiService.getApi(`${BASE}/GetRequestRiskPredictions`, { ...filter, maxItems });

export const getManagementDashboardExecutiveDailyBrief = (filter = {}) =>
  DefaultApiService.getApi(`${BASE}/GetExecutiveDailyBrief`, filter);

export const getManagementDashboardBenchmarkComparison = (filter = {}, dimensionType = "Province") =>
  DefaultApiService.getApi(`${BASE}/GetBenchmarkComparison`, { ...filter, dimensionType });

export const getManagementDashboardActions = (filter = {}) =>
  DefaultApiService.getApi(`${ACTION_BASE}/GetManagementActions`, filter);

export const getManagementDashboardAccess = () =>
  DefaultApiService.getApi(`${ACTION_BASE}/GetDashboardAccess`, {});

export const getManagementDashboardActionHistory = (actionId) =>
  DefaultApiService.getApi(`${ACTION_BASE}/GetActionHistory`, { actionId });

export const createManagementDashboardAction = (payload) =>
  DefaultApiService.postApi(`${ACTION_BASE}/CreateManagementAction`, payload);

export const updateManagementDashboardAction = (payload) =>
  DefaultApiService.postApi(`${ACTION_BASE}/UpdateManagementAction`, payload);

export const syncManagementDashboardActions = (filter = {}) =>
  DefaultApiService.postApi(
    `${ACTION_BASE}/SyncManagementActions?${queryString.stringify(filter)}`,
    {}
  );

export const exportExecutiveDailyBriefExcel = (filter = {}) =>
  DefaultApiService.getApi(`${ACTION_BASE}/ExportExecutiveDailyBriefExcel`, filter);

export const exportExecutiveDailyBriefPdf = (filter = {}) =>
  DefaultApiService.getApi(`${ACTION_BASE}/ExportExecutiveDailyBriefPdf`, filter);

export const exportManagementAllRequestList = (filter = {}) =>
  DefaultApiService.getApi(`${ALL_REQUEST_BASE}/Export`, filter);
